import '../css/odd-days.css'

function OddDaysRandom({currentMonth, currentYear}) {

  console.log("CURRENT INSIDE oddDaysRandom", currentMonth, currentYear)

  function getRandomArbitrary(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
  }

  return (
    <>
<div className="popo">events database</div>
      <div id="odd-days">

          {
        [...Array(daysInMonth(currentMonth, currentYear))].map((_, i) =>
          <div className="days-odd" key={i}>
          {((i + 1) ) ? 
              [...Array(getRandomArbitrary(0, 10))].map((e) => <div key={Math.floor(Math.random() * (100000 - 0) + 0)}>♦</div>) 
              : null}
            </div>
        )
          }

      </div>
    </>
  )
}

export default OddDaysRandom;
